import React from 'react';
import { FormField, Input } from '@amzn/awsui-components-react-v3/polaris';
import * as terGroups from './terGroups';

/**
 * The inputs of a TER group's default TERs and optional fields. Used by the TER group create and
 * detail pages.
 */

interface InputProps {
  values: terGroups.Metadata;
  disabled?: boolean;
  onChange: (values: terGroups.Metadata) => void;
}

/** The input for a workflow, content type or client of a new TER group; its id is the field name. */
export const MetadataInput = ({
  field,
  label,
  values,
  disabled,
  invalid,
  onBlur,
  onChange,
}: InputProps & {
  field: terGroups.MetadataField;
  label: string;
  invalid?: boolean;
  onBlur?: () => void;
}): JSX.Element => (
  <Input
    id={field}
    ariaLabel={label}
    value={values[field]}
    disabled={disabled}
    invalid={invalid}
    onBlur={onBlur}
    onChange={({ detail }): void => onChange({ ...values, [field]: detail.value })}
  />
);

/** A required default TER input with its constraint and, once entered, its error. */
export const DefaultTerField = ({
  field,
  label,
  values,
  disabled,
  onChange,
}: InputProps & { field: terGroups.DefaultTerField; label?: string }): JSX.Element => {
  const defaultTer = terGroups.DEFAULT_TERS.find(entry => entry.field === field);
  const error = terGroups.defaultTerError(values[field]);
  return (
    <FormField
      id={`${field}-field`}
      label={label}
      description={defaultTer && defaultTer.description}
      constraintText={terGroups.DEFAULT_TER_CONSTRAINT}
      errorText={error}
    >
      <Input
        id={field}
        ariaLabel={defaultTer && defaultTer.label}
        type="number"
        inputMode="decimal"
        step={0.001}
        value={values[field]}
        invalid={Boolean(error)}
        disabled={disabled}
        onChange={({ detail }): void => onChange({ ...values, [field]: detail.value })}
      />
    </FormField>
  );
};
